export default [
    {
        name: "NotFound",
        path: "/404",
        view: "error/NotFound",
        meta: { requiresAuth: false }

    },
    {
        name: "Landing",
        path: "/",
        view: "Landing",
        meta: { requiresAuth: false }
    },
    {
        name: "Login",
        path: "/login",
        view: "Login",
        meta: { requiresAuth: false }
    },
    {
        name: "InquiryEntry",
        path: "/inquiry/entry",
        view: "inquiry/InquiryEntry",
        meta: { requiresAuth: false }
    },
    {
        name: "Home",
        path: "/home",
        layout: "MainLayout",
        child: [
            /*
             * ダッシュボード
             */
            {
                name: "Dashboard",
                path: "/dashboard",
                view: "Dashboard",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: true}
                    ]
                }
            },
            /*
             * ユーザープロフィール
             */
            {
                name: "UserProfile",
                path: "/profile",
                view: "user_profile/UserProfile",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "プロフィール", disabled: true}
                    ]
                }
            },
            //企業プロフィール
            {
                name: "EditClientProfile",
                path: "/client",
                view: "master/client_profile/EditClientProfile",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                        { text: "企業情報", disabled: true }
                    ]
                },
            },
            /*
             * 実行予算書
             */
            {
                name: "ConstructionMaster",
                path: "/construction",
                view: "working_budget/construction/ConstructionMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事情報", disabled: true}
                    ]
                }
            },
            {
                name: "EditConstructionMaster",
                path: "/construction/edit/:id",
                view: "working_budget/construction/EditConstructionMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事情報", disabled: false, href: "/construction"},
                        { text: "工事情報編集", disabled: true}
                    ]
                }
            },
            {
                name: "CreateConstructionMaster",
                path: "/construction/entry",
                view: "working_budget/construction/CreateConstructionMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事情報", disabled: false, href: "/construction"},
                        { text: "工事情報登録", disabled: true}
                    ]
                }
            },
            {
                name: "ConstructionMasterDetail",
                path: "/construction/detail/:id",
                view: "working_budget/construction/ConstructionMasterDetail",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事情報", disabled: false, href: "/construction"},
                        { text: "工事情報詳細", disabled: true}
                    ]
                }
            },
            {
                name: "WorkingBudget",
                path: "/construction/:id/budget",
                view: "working_budget/WorkingBudget",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事情報", disabled: false, href: "/construction"},
                        { text: "実行予算書履歴一覧", disabled: true}
                    ]
                }
            },
            {
                name: "WorkingBudgetStore",
                path: "/construction/:id/budget/store/",
                view: "working_budget/WorkingBudgetStore",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事情報", disabled: false, href: "/construction"},
                        { text: "実行予算書作成", disabled: true}
                    ]
                },
            },
            {
                name: "WorkingBudgetEdit",
                path: "/construction/:id/budget/edit/:budget",
                view: "working_budget/WorkingBudgetEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事情報", disabled: false, href: "/construction"},
                        { text: "実行予算書編集", disabled: true}
                    ]
                },
            },
            {
                name: "WorkingBudgetInfo",
                path: "/construction/:id/budget/info/:budget",
                view: "working_budget/WorkingBudgetInfo",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事情報", disabled: false, href: "/construction"},
                        { text: "実行予算書情報", disabled: true}
                    ]
                },
            },
            {
                name: "AchievementInfo",
                path: "/construction/:id/budget/info/:budget/achievement",
                view: "working_budget/achievement/AchievementInfo",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事情報", disabled: false, href: "/construction"},
                        { text: "実績情報", disabled: true}
                    ]
                },
            },
            /*
             * 作業日報
             */
            {
                name: "WorkerDailyReport",
                path: "/report/daily/worker",
                view: "report/daily/worker/WorkerDailyReport",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "作業日報一覧", disabled: true}
                    ]
                }
            },
            {
                name: "WorkerDailyReportInfo",
                path: "/report/daily/worker/info",
                view: "report/daily/worker/WorkerDailyReportInfo",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "作業日報一覧", disabled: false, href: "/report/daily/worker"},
                        { text: "作業日報", disabled: true}
                    ]
                }
            },
            {
                name: "WorkerDailyReportEdit",
                path: "/report/daily/worker/edit",
                view: "report/daily/worker/WorkerDailyReportEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "作業日報一覧", disabled: false, href: "/report/daily/worker"},
                        { text: "作業日報編集", disabled: true}
                    ]
                }
            },
            {
                name: "WorkerDailyReportStore",
                path: "/report/daily/worker/store",
                view: "report/daily/worker/WorkerDailyReportStore",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "作業日報一覧", disabled: false, href: "/report/daily/worker"},
                        { text: "作業日報作成", disabled: true}
                    ]
                }
            },
            /*
             * 作業日報出張
             */
            {
              name: "WorkerDailyReportBusinessTripInfo",
              path: "/report/daily/worker/businessTrip/info",
              view: "report/daily/worker/WorkerDailyReportBusinessTripInfo",
              meta: {
                  requiresAuth: true,
                  breadcrumbs: [
                      { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                      { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
                      { text: "作業日報", disabled: false, href: "/report/daily/worker/info" },
                      { text: "作業日報出張", disabled: true }
                  ]
              }
            },
            {
              name: "WorkerDailyReportBusinessTripEdit",
              path: "/report/daily/worker/businessTrip/edit",
              view: "report/daily/worker/WorkerDailyReportBusinessTripEdit",
              meta: {
                  requiresAuth: true,
                  breadcrumbs: [
                      { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                      { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
                      { text: "作業日報作成", disabled: false, href: "/report/daily/worker/store" },
                      { text: "作業日報出張編集", disabled: true }
                  ]
              }
            },
            /*
             * 作業日報経費
             */
            {
              name: "WorkerDailyReportExpenseInfo",
              path: "/report/daily/worker/expense/info",
              view: "report/daily/worker/WorkerDailyReportExpenseInfo",
              meta: {
                  requiresAuth: true,
                  breadcrumbs: [
                      { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                      { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
                      { text: "作業日報", disabled: false, href: "/report/daily/worker/info" },
                      { text: "作業日報経費", disabled: true }
                  ]
              }
            },
            {
              name: "WorkerDailyReportExpenseEdit",
              path: "/report/daily/worker/expense/edit",
              view: "report/daily/worker/WorkerDailyReportExpenseEdit",
              meta: {
                  requiresAuth: true,
                  breadcrumbs: [
                      { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                      { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
                      { text: "作業日報作成", disabled: false, href: "/report/daily/worker/store" },
                      { text: "作業日報経費編集", disabled: true }
                  ]
              }
            },
            /*
             * 作業日報一括編集
             */
            {
              name: "WorkerDailyReportBulk",
              path: "/report/bulk/workerBulk",
              view: "report/bulk/worker/WorkerDailyReportBulk",
              meta: {
                  requiresAuth: true,
                  breadcrumbs: [
                      { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                      { text: "作業日報一括修正", disabled: true}
                  ]
              }
            },
            /*
             * 作業日報(経費)一括編集
             */
            {
              name: "WorkerDailyReportExpenseBulk",
              path: "/report/bulk/workerExpenseBulk",
              view: "report/bulk/worker/WorkerDailyReportExpenseBulk",
              meta: {
                  requiresAuth: true,
                  breadcrumbs: [
                      { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                      { text: "作業日報(経費)一括修正", disabled: true}
                  ]
              }
            },
            /*
             * 工事日報
             */
            {
                name: "ConstructionDailyReport",
                path: "/report/daily/construction",
                view: "report/daily/construction/ConstructionDailyReport",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事日報一覧", disabled: true}
                    ]
                }
            },
            {
                name: "ConstructionDailyReportStore",
                path: "/report/daily/construction/store/:id/:date",
                view: "report/daily/construction/ConstructionDailyReportStore",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事日報一覧", disabled: false, href: "/report/daily/construction"},
                        { text: "工事日報作成", disabled: true}
                    ]
                }
            },
            {
                name: "ConstructionDailyReportEdit",
                path: "/report/daily/construction/edit/:id/:date",
                view: "report/daily/construction/ConstructionDailyReportEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事日報一覧", disabled: false, href: "/report/daily/construction"},
                        { text: "工事日報再集計", disabled: true}
                    ]
                }
            },
            {
                name: "ConstructionDailyReportInfo",
                path: "/report/daily/construction/info/:id/:date",
                view: "report/daily/construction/ConstructionDailyReportInfo",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事日報一覧", disabled: false, href: "/report/daily/construction"},
                        { text: "工事日報", disabled: true}
                    ]
                }
            },
            {
                name: "WorkerDailyReportComform",
                path: "/report/daily/worker/comform",
                view: "report/daily/worker/WorkerDailyReportComform",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事日報一覧", disabled: false, href: "/report/daily/construction"},
                        { text: "作業日報確認", disabled: true}
                    ]
                }
            },
            {
                name: "WorkerDailyReportApproval",
                path: "/report/daily/worker/approval",
                view: "report/daily/worker/WorkerDailyReportApproval",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工事日報一覧", disabled: false, href: "/report/daily/construction"},
                        { text: "作業日報確認", disabled: false, href: "/report/daily/worker/comform"},
                        { text: "作業日報", disabled: true}
                    ]
                }
            },
            /*
             * 工番情報
             */
            {
                name: "ConstructionNumberFix",
                path: "/fix",
                view: "fix/ConstructionNumberFix",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工番情報", disabled: true}
                    ]
                }
            },
            {
                name: "ConstructionNumberFixEdit",
                path: "/fix/:id",
                view: "fix/ConstructionNumberFixEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "工番情報", disabled: false, href: "/fix"},
                        { text: "工番情報編集", disabled: true}
                    ]
                }
            },
            /*
             * マスタ
             */
            // 権限情報 ***************************************************
            {
                name: "PermissionMaster",
                path: "/permissions",
                view: "master/permission/PermissionMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "権限情報", disabled: true}
                    ]
                }
            },
            {
                name: "PermissionMasterEntry",
                path: "/permissions/store",
                view: "master/permission/PermissionMasterEntry",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "権限情報", disabled: false, href: "/permissions"},
                        { text: "権限情報登録", disabled: true}
                    ]
                }
            },
            {
                name: "PermissionMasterEdit",
                path: "/permissions/:id",
                view: "master/permission/PermissionMasterEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "権限情報", disabled: false, href: "/permissions"},
                        { text: "権限情報編集", disabled: true}
                    ]
                }
            },
            // ユーザー情報 ***************************************************
            {
                name: "UserMaster",
                path: "/user",
                view: "master/user/UserMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "ユーザー情報", disabled: true}
                    ]
                }
            },
            {
                name: "UserMasterEntry",
                path: "/user/store",
                view: "master/user/UserMasterEntry",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "ユーザー情報", disabled: false, href: "/user"},
                        { text: "ユーザー情報登録", disabled: true}
                    ]
                }
            },
            {
                name: "UserMasterEdit",
                path: "/user/:id",
                view: "master/user/UserMasterEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "ユーザー情報", disabled: false, href: "/user"},
                        { text: "ユーザー情報編集", disabled: true}
                    ]
                }
            },
            // 部署情報 ***************************************************
            {
                name: "DepartmentMaster",
                path: "/department",
                view: "master/department/DepartmentMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "部署情報", disabled: true}
                    ]
                }
            },
            {
                name: "CreateDepartmentMaster",
                path: "/department/entry",
                view: "master/department/CreateDepartmentMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "部署情報", disabled: false, href: "/department"},
                        { text: "部署情報登録", disabled: true}
                    ]
                },
            },
            {
                name: "EditDepartmentMaster",
                path: "/department/edit/:id",
                view: "master/department/EditDepartmentMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "部署情報", disabled: false, href: "/department"},
                        { text: "部署情報編集", disabled: true}
                    ]
                },
            },
            // 取引先情報 ***************************************************
            {
                name: "SuppliersMaster",
                path: "/suppliers",
                view: "master/suppliers/SuppliersMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "取引先情報", disabled: true}
                    ]
                }
            },
            {
              name: "CreateSuppliersMaster",
              path: "/suppliers/entry",
              view: "master/suppliers/CreateSuppliersMaster",
              meta: {
                requiresAuth: true,
                breadcrumbs: [
                    { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                    { text: "取引先情報", disabled: false, href: "/suppliers"},
                    { text: "取引先情報登録", disabled: true}
                ]
              }
            },
            {
                name: "EditSuppliersMaster",
                path: "/suppliers/edit/:id",
                view: "master/suppliers/EditSuppliersMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "取引先情報", disabled: false, href: "/suppliers"},
                        { text: "取引先情報編集", disabled: true}
                    ]
                }
            },
            // 外注業者情報 ***************************************************
            // {
            //     name: "SubcontractorMaster",
            //     path: "/subcontractor",
            //     view: "master/subcontractor/SubcontractorMaster",
            //     meta: {
            //         requiresAuth: true,
            //         breadcrumbs: [
            //             { text: "ダッシュボード", disabled: false, href: "/dashboard"},
            //             { text: "外注作業者情報", disabled: true}
            //         ]
            //     }
            // },
            // {
            //     name: "EditSubcontractorMaster",
            //     path: "/subcontractor/edit/:id",
            //     view: "master/subcontractor/EditSubcontractorMaster",
            //     meta: {
            //         requiresAuth: true,
            //         breadcrumbs: [
            //             { text: "ダッシュボード", disabled: false, href: "/dashboard"},
            //             { text: "外注作業者情報", disabled: false, href: "/subcontractor"},
            //             { text: "外注作業者情報編集", disabled: true}
            //         ]
            //     }
            // },
            // {
            //     name: "CreateSubcontractorMaster",
            //     path: "/subcontractor/entry",
            //     view: "master/subcontractor/CreateSubcontractorMaster",
            //     meta: {
            //         requiresAuth: true,
            //         breadcrumbs: [
            //             { text: "ダッシュボード", disabled: false, href: "/dashboard"},
            //             { text: "外注作業者情報", disabled: false, href: "/subcontractor"},
            //             { text: "外注作業者情報登録", disabled: true}
            //         ]
            //     }
            // },
            // 機材情報 ***************************************************
            // {
            //     name: "EquipmentMaster",
            //     path: "/equipment",
            //     view: "master/equipment/EquipmentMaster",
            //     meta: {
            //         requiresAuth: true,
            //         breadcrumbs: [
            //             { text: "ダッシュボード", disabled: false, href: "/dashboard"},
            //             { text: "機材情報", disabled: true}
            //         ]
            //     }
            // },
            // {
            //     name: "EditEquipmentMaster",
            //     path: "/equipment/edit/:id",
            //     view: "master/equipment/EditEquipmentMaster",
            //     meta: {
            //         requiresAuth: true,
            //         breadcrumbs: [
            //             { text: "ダッシュボード", disabled: false, href: "/dashboard"},
            //             { text: "機材情報", disabled: false, href: "/equipment"},
            //             { text: "機材情報編集", disabled: true}
            //         ]
            //     }
            // },
            // {
            //       name: "CreateEquipmentMaster",
            //       path: "/equipment/entry",
            //       view: "master/equipment/CreateEquipmentMaster",
            //       meta: {
            //         requiresAuth: true,
            //         breadcrumbs: [
            //           { text: "ダッシュボード", disabled: false, href: "/dashboard"},
            //           { text: "機材情報", disabled: false, href: "/equipment"},
            //           { text: "機材情報登録", disabled: true}
            //         ]
            //       }
            // },
            // 費目情報 ***************************************************
            {
                name: "ExpenseMaster",
                path: "/expense",
                view: "master/expense/ExpenseMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                        { text: "費目情報", disabled: true }
                    ]
                }
            },
            {
                name: "EditExpenseMaster",
                path: "/expense/edit/:id",
                view: "master/expense/EditExpenseMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                        { text: "費目情報", disabled: false, href: "/expense" },
                        { text: "費目情報編集", disabled: true }
                    ]
                }
            },
            {
                name: "CreateExpenseMaster",
                path: "/expense/entry",
                view: "master/expense/CreateExpenseMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                        { text: "費目情報", disabled: false, href: "/expense" },
                        { text: "費目情報登録", disabled: true }
                    ]
                }
            },
            {
                name: "CategoryMaster",
                path: "/category",
                view: "master/expense/categories/CategoryMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                        { text: "費目情報", disabled: false, href: "/expense" },
                        { text: "カテゴリ情報", disabled: true }
                    ]
                }
            },
            {
                name: "CategoryMasterEdit",
                path: "/category/edit/:id",
                view: "master/expense/categories/CategoryMasterEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                        { text: "費目情報", disabled: false, href: "/expense" },
                        { text: "カテゴリ情報", disabled: false, href: "/category" },
                        { text: "カテゴリ情報編集", disabled: true }
                    ]
                }
            },
            {
                name: "CategoryMasterEntry",
                path: "/category/entry",
                view: "master/expense/categories/CategoryMasterEntry",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                        { text: "費目情報", disabled: false, href: "/expense" },
                        { text: "カテゴリ情報", disabled: false, href: "/category" },
                        { text: "カテゴリ情報登録", disabled: true }
                    ]
                }
            },
            // 費目テンプレート情報 ***************************************************
            {
                name: "ExpenseTemplate",
                path: "/template",
                view: "working_budget/template/ExpenseTemplate",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "費目テンプレート情報", disabled: true}
                    ]
                }
            },
            {
                name: "ExpenseTemplateEntry",
                path: "/template/entry",
                view: "working_budget/template/ExpenseTemplateEntry",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "費目テンプレート情報", disabled: false, href: "/template"},
                        { text: "費目テンプレート情報登録", disabled: true}
                    ]
                }
            },
            {
                name: "ExpenseTemplateEdit",
                path: "/template/edit/:id",
                view: "working_budget/template/ExpenseTemplateEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "費目テンプレート情報", disabled: false, href: "/template"},
                        { text: "費目テンプレート情報編集", disabled: true}
                    ]
                }
            },
            // 集計費目情報 ***************************************************
            {
                name: "AggregateMaster",
                path: "/aggregate",
                view: "master/aggregate/AggregateMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "集計費目情報", disabled: true}
                    ]
                }
            },
            {
                name: "AggregateMasterEntry",
                path: "/aggregate/entry",
                view: "master/aggregate/AggregateMasterEntry",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "集計費目情報", disabled: false, href: "/aggregate"},
                        { text: "集計費目情報登録", disabled: true}
                    ]
                },
            },
            {
                name: "AggregateMasterEdit",
                path: "/aggregate/edit/:id",
                view: "master/aggregate/AggregateMasterEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "集計費目情報", disabled: false, href: "/aggregate"},
                        { text: "集計費目情報編集", disabled: true}
                    ]
                },
            },
            // 等級情報 ***************************************************
            {
                name: "RankMaster",
                path: "/rank",
                view: "master/rank/RankMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "等級情報", disabled: true}
                    ]
                }
            },
            {
                name: "RankMasterEntry",
                path: "/rank/entry",
                view: "master/rank/RankMasterEntry",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "等級情報", disabled: false, href: "/rank"},
                        { text: "等級情報登録", disabled: true}
                    ]
                },
            },
            {
                name: "RankMasterEdit",
                path: "/rank/edit/:id",
                view: "master/rank/RankMasterEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "等級情報", disabled: false, href: "/rank"},
                        { text: "等級情報編集", disabled: true}
                    ]
                },
            },
            // 分析情報 ***************************************************
            {
                name: "Analysis",
                path: "/analysis",
                view: "analysis/Analysis",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "分析情報", disabled: true}
                    ]
                }
            },
            // お知らせ情報 ***************************************************
            {
                name: "NotificationMaster",
                path: "/notification",
                view: "master/notification/NotificationMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "お知らせ情報", disabled: true}
                    ]
                }
            },
            {
                name: "CreateNotificationMaster",
                path: "/notification/entry",
                view: "master/notification/CreateNotificationMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "お知らせ情報", disabled: false, href: "/notification"},
                        { text: "お知らせ情報登録", disabled: true}
                    ]
                },
            },
            {
                name: "EditNotificationMaster",
                path: "/notification/edit/:id",
                view: "master/notification/EditNotificationMaster",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "お知らせ情報", disabled: false, href: "/notification"},
                        { text: "お知らせ情報編集", disabled: true}
                    ]
                },
            },
            // 問い合わせ情報一覧画面 ***************************************************
            {
                name: "Inquiry",
                path: "/inquiry",
                view: "inquiry/Inquiry",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                        { text: "問い合わせ一覧", disabled: true }
                    ]
                }
            },
            {
                name: "InquiryInfo",
                path: "/inquiry/edit/:id",
                view: "inquiry/InquiryInfo",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard" },
                        { text: "問い合わせ一覧", disabled: false, href: "/inquiry" },
                        { text: "問い合わせ閲覧", disabled: true }
                    ]
                },
            },
            // システムお知らせ情報 ***************************************************
            {
                name: "SystemNotification",
                path: "/system_notification",
                view: "master/notification/SystemNotification",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "システムお知らせ情報", disabled: true}
                    ]
                }
            },
            {
                name: "SystemNotificationcEntry",
                path: "/system_notification/entry",
                view: "master/notification/SystemNotificationcEntry",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "システムお知らせ情報", disabled: false, href: "/system_notification"},
                        { text: "システムお知らせ情報登録", disabled: true}
                    ]
                },
            },
            {
                name: "SystemNotificationEdit",
                path: "/system_notification/edit/:id",
                view: "master/notification/SystemNotificationEdit",
                meta: {
                    requiresAuth: true,
                    breadcrumbs: [
                        { text: "ダッシュボード", disabled: false, href: "/dashboard"},
                        { text: "システムお知らせ情報", disabled: false, href: "/system_notification"},
                        { text: "システムお知らせ情報編集", disabled: true}
                    ]
                },
            },
        ]
    }
];
